import React from "react";
import { Main, Section, Aside } from "../../../layout/index";
import { WPRender } from "../../../components";
import Applications from "../../../components/Applications/Applications";
import "./MemberBenefits.css";

const MemberBenefits = () => {
  const navList = [
    { label: "Join/Renew", value: "join-renew", key: 1 },
    { label: "Member Benefits", value: "member-benefits", key: 2 },
    { label: "Member Directory", value: "member-directory", key: 4 },
    { label: "Leadership", value: "leadership", key: 5 },
    { label: "Emergency Panel", value: "emergency-panel", key: 6 },
  ];

  return (
    <Main slug="member-benefits" title="MEMBER BENEFITS">
      <Aside header="MEMBERSHIP" navList={navList} active={2}>
        <Applications />
      </Aside>
      <Section>
        <WPRender postType="membership" slug="member-benefits" />
      </Section>
    </Main>
  );
};

export default MemberBenefits;
